/* eslint-disable max-len */

export default {
    name: 'operationTransferDetails',
    /**
     * @override
     */
    data() {
        return {
            transferDetails: []
        };
    },
    props: {
        uuid: {
            type: String,
            required: true
        },
        isPP: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        /**
         * Obtenemos los detalles de traspaso de la operación
         */
        fetchData() {
            this.$operationsService.getOperationTransferDetails(this.uuid).then(res => {
                this.transferDetails.items = res.data.operations_transfer_details || [];
            });
        }
    },
    /**
     * @override
     */
    beforeMount() {
        if (this.isPP) {
            this.transferDetails = {
                fields: [
                    {
                        key: 'original_date',
                        label: 'Fecha origen'
                    },
                    {
                        key: 'key_global_operation_type',
                        label: 'Tipo de operación'
                    },
                    {
                        key: 'gross_amount',
                        label: 'Líquido'
                    },
                    {
                        key: 'shares',
                        label: 'Participaciones'
                    },
                    {
                        key: 'reduced_shares',
                        label: 'Participaciones con reducción'
                    },
                    {
                        key: 'reduced_gross_amount',
                        label: 'Líquido con reducción'
                    },
                    {
                        key: 'rights_type',
                        label: 'Tipo de derechos'
                    },
                    {
                        key: 'origin',
                        label: 'Imputación'
                    }
                ],
                items: []
            };
        } else {
            this.transferDetails = {
                fields: [
                    {
                        key: 'original_date',
                        label: 'Fecha origen'
                    },
                    {
                        key: 'key_global_operation_type',
                        label: 'Operación'
                    },
                    {
                        key: 'fiscal_amount',
                        label: 'Importe adquisición'
                    },
                    {
                        key: 'gross_amount',
                        label: 'Importe traspaso'
                    },
                    {
                        key: 'shares',
                        label: 'Participaciones'
                    }
                ],
                items: []
            };
        }
        this.fetchData();
    }
};
